/* eslint-disable react-hooks/exhaustive-deps */
// import TicketMenuManagementCreate from "./lib/create";
import { useParams } from 'react-router';
import { useEffect } from 'react';

import Gap from 'components/gap';
import { useTypedSelector } from 'common/hooks/useTypedSelector';
import TicketDetailInfo from './lib/info';
import { useActions } from 'common/hooks/useActions';
import AppLoading from 'components/appLoading';

import * as S from './styles';

export default function TicketIncidentsDetailPage() {
  const { ticketsDetailIncident, ticketClose } = useTypedSelector((state: any) => state.Tickets);
  const { ticketDetailIncidentRequestAction } = useActions();

  const params = useParams();

  useEffect(() => {
    ticketDetailIncidentRequestAction(params?.id);
  }, []);

  return (
    <S.Container>
      <S.Head>
        <S.Title>Incident Detail</S.Title>
      </S.Head>
      <Gap size="20px" />
      <S.Div className="row">
        {/* <S.Div className="col-md-6">
          <TicketDetailChat data={ticketDetail.data} />
        </S.Div> */}
        <S.Div className="col-md-12">
          <TicketDetailInfo data={ticketsDetailIncident.data} />
        </S.Div>
        {/* <S.Div className="col-md-6">
          <ticketsDetailIncidentTypeInfo data={ticketsDetailIncident.data} />
        </S.Div> */}
      </S.Div>

      <AppLoading loading={ticketsDetailIncident.loading || ticketClose.loading} />
    </S.Container>
  );
}
